import { render, staticRenderFns } from "./OfficeRoleCard.vue?vue&type=template&id=0ac6ba70&scoped=true&"
import script from "./OfficeRoleCard.vue?vue&type=script&lang=js&"
export * from "./OfficeRoleCard.vue?vue&type=script&lang=js&"
import style0 from "./OfficeRoleCard.vue?vue&type=style&index=0&id=0ac6ba70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac6ba70",
  null
  
)

export default component.exports